import React from 'react';


const Lab3: React.FC = () => {
  return (
    <div id="wd-lab3">
      <h2>Lab 3 - Introduction to JavaScript</h2>
      <p>This lab covers the basics of JavaScript.</p>
    </div>
  );
}

export default Lab3;
